import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Link, Typography } from "@carrotfertility/carotene-core"
import { RegistrationErrorLayout } from "./RegistrationLayouts"
import { RegistrationFlowTitle } from "./RegistrationFlowTitle"
import { PiiText } from "#/services/tracking"
import { EmployeeSupportUrl } from "#/utils/EmployeeSupportLink"
import { ltr } from "#/services/locale/bidirectional-text"

export function RegistrationEmailAlreadyInUse({ email }: { email: string | null }): JSX.Element {
  const intl = useIntl()
  const header = intl.formatMessage({ defaultMessage: "Something went wrong" })

  return (
    <>
      <RegistrationFlowTitle title={header} />
      <RegistrationErrorLayout
        header={header}
        description={
          <Typography>
            <FormattedMessage
              defaultMessage="To proceed with registration using {email}, <link>please reach out to our Care Team</link>. If you are in the US, you can also call us at 1 888-817-9040 to talk to one of our Carrot Companions."
              values={{
                email: <PiiText>{ltr(email)}</PiiText>,
                link: (text) => (
                  <Link color="inherit" href={EmployeeSupportUrl} target="_blank">
                    {text}
                  </Link>
                )
              }}
            />
          </Typography>
        }
      />
    </>
  )
}
